export enum DetailMode {
  NORMAL = 'normal',
  EDITION = 'edition',
  TOUR = 'tour',
}

export const YESNO = [
  { value: true, label_en: 'Yes', label_fr: 'Oui' },
  { value: false, label_en: 'No', label_fr: 'Non' },
]

export enum Gender {
  MALE = 'male',
  FEMALE = 'female',
  OTHER = 'other',
  UNKNOWN = 'unknown',
}
export const GENDERS = [
  { value: Gender.MALE, label_en: 'Male', label_fr: 'Homme' },
  { value: Gender.FEMALE, label_en: 'Female', label_fr: 'Femme' },
  { value: Gender.OTHER, label_en: 'Other', label_fr: 'Autre' },
  { value: Gender.UNKNOWN, label_en: 'Unknown', label_fr: 'Non renseigné' },
]

export enum WeekDay {
  MONDAY = 'monday',
  TUESDAY = 'tuesday',
  WEDNESDAY = 'wednesday',
  THURSDAY = 'thursday',
  FRIDAY = 'friday',
  SATURDAY = 'saturday',
  SUNDAY = 'sunday',
}
export const WEEK_DAYS = [
  { value: WeekDay.MONDAY, label_en: 'Monday', label_fr: 'Lundi' },
  { value: WeekDay.TUESDAY, label_en: 'Tuesday', label_fr: 'Mardi' },
  { value: WeekDay.WEDNESDAY, label_en: 'Wednesday', label_fr: 'Mercredi' },
  { value: WeekDay.THURSDAY, label_en: 'Thursday', label_fr: 'Jeudi' },
  { value: WeekDay.FRIDAY, label_en: 'Friday', label_fr: 'Vendredi' },
  { value: WeekDay.SATURDAY, label_en: 'Saturday', label_fr: 'Samedi' },
  { value: WeekDay.SUNDAY, label_en: 'Sunday', label_fr: 'Dimanche' },
]
